class ErrorReportsService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
    this.url = `${this.config.apiRoot}/errorReports`;
  }

  getErrorReportUrl(type, batchId) {
    let url = `${this.url}/${type}`;

    if (batchId) {
      url += `/${batchId}`;
    }

    return this.httpDim.get(url, this.config);
  }
}

ErrorReportsService.$inject = ['httpDim', 'config'];

export default ErrorReportsService;



// WEBPACK FOOTER //
// ./app/components/errorReport/errorReport.service.js